export default {"src":"/_next/static/media/ush-white.3590c13b.svg","height":164,"width":164,"blurWidth":0,"blurHeight":0};